export interface CardCategoriesProps {
  category?: string;
  subCategory?: string;
}

export function CardCategories({ category, subCategory }: CardCategoriesProps) {
  if (!category && !subCategory) return null;

  return (
    <header className="mt-8 flex justify-between gap-4 text-sm font-normal text-muted-foreground lg:mt-0">
      {category && (
        <span className="min-w-0 shrink truncate" title={category}>
          {category}
        </span>
      )}
      {subCategory && (
        <span
          className="min-w-0 shrink-2 truncate text-right"
          title={subCategory}
        >
          {subCategory}
        </span>
      )}
    </header>
  );
}
